<div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">{{ 'modal.shipping_policy' | optimizedI18n }}</h5>
      <button class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
        <fa-icon [icon]="faClose"></fa-icon>
      </button>
    </div>
    <div class="modal-body">
      <div class="mt-3">
        <p >
            Las compras que se hacen dentro de la <b>plataforma plataforma</b> son dentro del territorio colombiano, en esta fase inicial de la plataforma, para los departamentos de Cundinamarca (Bogotá y alrededores) y Antioquia (Medellín y alrededores).
        </p>
        <p>
            En cuanto se confirma el pago de tu compra, tu orden ya tendrá estatus de confirmada y plataforma dispone de <b>3 - 15 días hábiles</b> para la entrega según los productos, algunos toman mayor tiempo por su elaboración, en la dirección informada por el cliente. Es importante aclarar que los tiempos de entrega mencionados pueden variar por motivos ajenos a plataforma. Esto se debe a que los envíos son contratados con empresas de transporte y mensajería externas y plataforma no se hace responsable por demoras en estos.
        </p>
        <p>
            En caso tal de que el producto no llega a su destino en estos tiempos, 
            el cliente deberá comunicarse con nosotros enviando un correo a la siguiente 
            dirección: servicioalcliente@plataformaequino.com con el 
            asunto: <b>Compra # (Número de tu orden)</b> no recibida e 
            informando lo sucedido en el correo. Luego de que se haga la 
            verificación correspondiente y confirmada la perdida o no entrega 
            de la orden, plataforma tendrá un peridodo de 15 días hábiles para resolver 
            el caso, bien sea con la devolución del dinero o el envió de los productos comprados.
        </p>
        <p>
            Los costos de envió serán calculados a partir de tu orden de compra, productos, proveedores que envian y destino, y por lo tando, son una tarifa variable en cada orden de compra. En caso tal de que el comprador acceda a una promoción o campaña de envió gratis, no tendrá que pagar el envió. En todos los casos normales, el comprador asume este costo de la compra.
        </p>
      </div>
    </div>
  </div>
  